import { Link } from "react-router-dom";
import styled from "styled-components";

export const Main = styled.main``;

export const MainSection = styled.section`
  margin: 2rem 0;
  padding: 6rem 0;
`;
export const SctionTitle = styled.h2`
  font-size: ${(props) => props.theme.font.Xlarge};
`;
export const SctionParagraph = styled.p`
  font-size: ${(props) => props.theme.font.med};
`;

export const SectionLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
`;
export const CustomDivider = styled.div`
  content: " ";
  height: 5px;
  width: 65px;
  background-color: ${(props) => props.theme.colors.primary};
  ${({ isCenter }) => isCenter && "margin: 0 auto;"}

  display: flex;
  justify-content: space-between;
  &:before {
    content: "";
    width: calc(100% / 4);
    background-color: ${(props) => props.theme.colors.secondary};
  }

  &:after {
    content: "";
    width: calc(100% / 4);
    background-color: ${(props) => props.theme.colors.secondary};
  }
`;
